import React from 'react'

const LegalLinks = () => {
  return (
    <p className="text-muted text-center">
      <small>
        <a href="/legal/#terms">Terms</a> |{' '}
        <a href="/legal/#privacy">Privacy</a> |{' '}
        <a href="/legal/#cookies">Cookies</a>
      </small>
    </p>
  )
}

export default LegalLinks
